import React from 'react';
import { Link } from 'react-router-dom';
import TeamComponent from './TeamComponent';
import WhatWeDoComponent from './WhatWeDoComponent';
import { FaInfoCircle } from 'react-icons/fa';

const AboutUsComponent = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-4 px-2 lg:px-20">
      <div className="max-w-5xl mx-auto bg-white rounded-lg p-8">
        <h2 className="text-3xl font-bold text-blue-900 mb-6 text-left flex items-center gap-2">
          <FaInfoCircle className="text-indigo-600 text-3xl" />
          About Us
        </h2>
        <hr className='mb-4'/>
        <div className='mb-3' >
            <img style={{ margin: "0 auto", width: "auto" }} src='/logo512.png' alt='ipsa_logo' />
        </div>
        <p className="text-lg text-gray-700 mb-6 text-justify">
            The <strong>Institute for Patient Safety Digital Platform</strong>  is a web- and mobile-based application designed to support healthcare organizations in their journey toward patient safety excellence. The system provides a unified digital ecosystem that enables hospitals, clinics, and training institutions to assess, learn, improve, and demonstrate patient safety performance through evidence-based frameworks. <br/>
            The platform aligns with the <strong>World Health Organization (WHO) Global Patient Safety Action Plan (2021–2030), Joint Commission International (JCI) standards, and ISQua</strong>  principles of quality improvement.        
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
          <div className='bg-blue-50 p-6 rounded-xl shadow-lg'>
            <h3 className="text-3xl font-semibold text-blue-900">Vision</h3>
            <hr className='mb-4 mt-4 border-blue-200'/>
            <p className="text-gray-700 text-justify">
              To be a world-leading digital hub enabling healthcare organizations to achieve zero preventable harm through continuous learning and data-driven improvement.            
            </p>
          </div>
          <div className='bg-blue-50 p-6 rounded-xl shadow-lg'>
            <h3 className="text-3xl font-semibold text-blue-900 ">Mission</h3>
            <hr className='mb-4 mt-4 border-blue-200'/>
            <p className="text-gray-700 text-justify">
              To empower healthcare organizations with tools, insights, and learning systems that enhance patient safety culture, minimize risk, and elevate standards of care.            
            </p>
          </div>
        </div>

        <WhatWeDoComponent/>

        <TeamComponent/>

        <div className="text-center">
          <p className="text-gray-700">
            Learn more about our work, explore partnership opportunities, or reach out to join our mission.
          </p>
          <Link
            to="/contact-us"
            className="inline-block mt-4 bg-blue-900 text-white px-6 py-2 rounded-md hover:bg-blue-800 transition"
          >
            Contact Us
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AboutUsComponent;
